/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('public.employee.profile').directive('gccsEmployeeProfileDocumentsHeader', () =>
  ({
    restrict: 'A',
    controller: 'EmployeeProfileDocumentsHeaderController',
    controllerAs: 'employeeProfileDocumentsHeaderCtrl',
    template: require('./template.pug'),
    scope: {
      nameOrderParam: '='
    }
  })
);
